import { TextLink } from '@edsn/pie-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { KnowledgeArticleListDto } from '#pie/internal/api/pie-bff';
import { SkeletonLines } from '../skeleton-lines/SkeletonLines';
import { Stack } from '../stack/Stack';
import { Text } from '../text/Text';

interface KnowledgeTabArticlesProps {
  groupedArticles: Record<string, KnowledgeArticleListDto[]>;
  isLoading: boolean;
}

export const KnowledgeTabArticles = ({
  groupedArticles,
  isLoading,
}: KnowledgeTabArticlesProps) => {
  const [showAll, setShowAll] = useState<Record<string, boolean>>({});
  const { t } = useTranslation();

  const handleToggle = (category: string) => {
    setShowAll((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };
  return (
    <Stack gap="md" className="grid grid-cols-2 gap-6 lg:grid-cols-4">
      {Object.entries(groupedArticles)
        .sort(([categoryA], [categoryB]) => categoryA.localeCompare(categoryB))
        .map(([category, articles]) => {
          const expanded = showAll[category] ?? false;
          return isLoading ? (
            <SkeletonLines key={category} lines={2} />
          ) : (
            <Stack key={category}>
              <Text as="h3" variant="h6" className="pb-3">
                {category}
              </Text>
              {(expanded ? articles : articles.slice(0, 3)).map((article) => (
                <Link
                  key={article.id}
                  to={`/kennisbank/${article.id}`}
                  className="pb-2 hover:underline"
                >
                  {article.title}
                </Link>
              ))}
              {articles.length > 3 && (
                <TextLink
                  className="self-start mt-1"
                  onClick={() => handleToggle(category)}
                  action="secondary"
                >
                  {expanded
                    ? t('knowledge_base.tab.button.show_fewer')
                    : t('knowledge_base.tab.button.show_more')}
                </TextLink>
              )}
            </Stack>
          );
        })}
    </Stack>
  );
};
